import React, { useState, useEffect } from "react";
import {
  FaTachometerAlt,
  FaUsers,
  FaBan,
  FaFlag,
  FaChevronDown,
  FaChevronRight,
} from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import adminLogo from "../../../../Assets/Images/adminLogo.svg";
import { RxDashboard } from "react-icons/rx";
import { LuUsers } from "react-icons/lu";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userMenuOpen, setUserMenuOpen] = useState(true);
  const [activeItem, setActiveItem] = useState("Users List"); // Default active item

  // Determine active path for styling
  const activePath = location.pathname;

  // Update activeItem based on the current path
  useEffect(() => {
    if (activePath.includes("/admin/userslist")) {
      setActiveItem("Users List");
    } else if (activePath.includes("/admin/deletedusers")) {
      setActiveItem("Deleted Users");
    } else if (activePath.includes("/admin/blockedusers")) {
      setActiveItem("Report Blocked Users");
    } else if (activePath.includes("/admin/reportusers")) {
      setActiveItem("Report Users");
    } else {
      setActiveItem("Dashboard"); // Fallback if no other route matches
    }

    // Automatically open User Management if any of its child paths are active
    if (
      activePath.includes("/admin/userslist") ||
      activePath.includes("/admin/deletedusers") ||
      activePath.includes("/admin/blockedusers") ||
      activePath.includes("/admin/reportusers")
    ) {
      setUserMenuOpen(true);
    } else {
      setUserMenuOpen(false); // Close if none of the child routes match
    }
  }, [activePath]);

  return (
    <div className="min-w-[268px] bg-white text-black p-4">
      {/* Logo */}
      <div className="mb-8 flex justify-center">
        <img src={adminLogo} alt="Admin Logo" className="h-12 w-auto" />
      </div>

      {/* Main Menu */}
      <nav className="space-y-4">
        {/* Dashboard */}
        <div
          className={`flex items-center gap-3 p-3 px-3.5 rounded-md cursor-pointer hover:opacity-50 ${activePath === "/admin/dashboard"
            ? "bg-[var(--primary-color)] text-white"
            : ""
            }`}
          onClick={() => navigate("/admin/dashboard")}
        >
          <RxDashboard
            size={24}
            className={`${activePath === "/admin/dashboard" ? "text-white" : "text-black"
              }`}
          />
          <span
            className={`${activePath === "/admin/dashboard"
              ? "text-sm text-white font-semibold"
              : "text-sm"
              }`}
          >
            Dashboard
          </span>
        </div>

        {/* User Management */}
        <div>
          <div
            className={`flex items-center justify-between cursor-pointer p-3 px-3.5 rounded-md ${userMenuOpen
              ? "bg-[var(--primary-color)] text-white"
              : "hover:opacity-50"
              }`}
            onClick={() => setUserMenuOpen(!userMenuOpen)}
          >
            <div className="flex items-center gap-2  ">
              <LuUsers size={24} />
              <span className="text-sm font-semibold">User Management</span>
            </div>
            {userMenuOpen ? <FaChevronDown /> : <FaChevronRight />}
          </div>

          {userMenuOpen && (
            <div className="space-y-4 pl-6 mt-4">
              {/* Users List */}
              <div
                className={`flex items-center gap-2 cursor-pointer ${activeItem === "Users List"
                  ? "text-[#7104F8] text-sm font-semibold"
                  : "text-[#7C7C7C] text-sm font-normal"
                  }`}
                onClick={() => {
                  setActiveItem("Users List");
                  navigate("/admin/userslist");
                }}
              >
                <span
                  className={`${activeItem === "Users List"
                    ? "text-[#7104F8] font-semibold"
                    : "text-[#7C7C7C] font-normal"
                    }`}
                >
                  Users List
                </span>
              </div>

              {/* Deleted Users */}
              <div
                className={`flex items-center gap-2 cursor-pointer ${activeItem === "Deleted Users"
                    ? "text-[#7104F8] text-sm font-semibold"
                    : "text-[#7C7C7C] text-sm font-normal"
                  }`}
                onClick={() => {
                  setActiveItem("Deleted Users");
                  navigate("/admin/deletedusers");
                }}
              >
                <span
                  className={`${activeItem === "Deleted Users"
                      ? "text-[#7104F8] font-semibold"
                      : "text-[#7C7C7C] font-normal"
                    }`}
                >
                  Deleted Users
                </span>
              </div>

              {/* Report Blocked Users */}
              <div
                className={`flex items-center gap-2 cursor-pointer ${activeItem === "Report Blocked Users"
                  ? "text-[#7104F8] text-sm font-semibold"
                  : "text-[#7C7C7C] text-sm font-normal"
                  }`}
                onClick={() => {
                  setActiveItem("Report Blocked Users");
                  navigate("/admin/blockedusers");
                }}
              >
                <span
                  className={`${activeItem === "Report Blocked Users"
                    ? "text-[#7104F8] text-sm font-semibold"
                    : "text-[#7C7C7C] text-sm font-normal"
                    }`}
                >
                  Blocked Users
                </span>
              </div>

              {/* Report Users */}
              {/* <div
                className={`flex items-center gap-2 cursor-pointer ${
                  activeItem === "Report Users"
                    ? "text-[#7104F8] text-sm font-semibold"
                    : "text-[#7C7C7C] text-sm font-normal"
                }`}
                onClick={() => {
                  setActiveItem("Report Users");
                  navigate("/admin/reportusers");
                }}
              >
                <span
                  className={`${
                    activeItem === "Report Users"
                      ? "text-[#7104F8] font-semibold"
                      : "text-[#7C7C7C] font-normal"
                  }`}
                >
                  Report Users
                </span>
              </div> */}
            </div>
          )}
        </div>
      </nav>
    </div>
  );
}
